import { useDispatch, useSelector } from "react-redux";
import SuperUserLayout from "../SuperUserLayout";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import useFetch from "../../../hook/useFetch";
import { notificationActions } from "../../../store/notification-slice";
import useFilter from "../../../hook/useFilter";
import useIsMobile from "../../../hook/useIsMobile";
import MobileComponent from "./datatable/mobile";
import DesktopComponent from "./datatable/desktop";
import { logActions } from "../../../store/log-slice";
import { useLocation } from "react-router-dom";


export default function Logs() {

    let token = useSelector(state => state.user.token)
    const [logs, setLogs] = useState()

    const { get } = useFetch()

    let dispatch = useDispatch()

    const { convertToArray } = useFilter()

    const { isMobile } = useIsMobile()

    let location = useLocation()
    const fetchLogs = () => {
        setLogs(null)
        dispatch(logActions.resetLogs())
        get(`/admin/logs?token=${token}`, null, (data) => {
            dispatch(notificationActions.setNotification({
                message: data,
                status: false
            }))
        }, (data) => {
            data = convertToArray(data)
            setLogs(data)
            dispatch(logActions.setLogs(data))

        })
    }

    useEffect(() => {
        fetchLogs()
    }, [])

    useEffect(() => {
        if (location.state && location.state.refetch) {

            fetchLogs()
        }
    }, [location.state])

    if (!logs) {
        return <Skeleton count={50} />
    }

    return <SuperUserLayout>
        <div className="rso-pages card shadow  bg-white rounded p-3 m-0">{isMobile ? <MobileComponent /> : <DesktopComponent />}</div>
    </SuperUserLayout>
}